import * as THREE from "three";
import ActionItem from "./actionItem"
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader'
const defaultCrossDuration = 0.1
const START_FRAME = 1
export default class ActionMgr {
    constructor(modelScene) {
        this.actionsMap = new Map()
        this.currentActionKey = undefined
        this.idleActionKey = undefined
        this.modelScene = modelScene
        if(modelScene.getObjectByName("Armature")){
            this.rootBone = modelScene.getObjectByName("Armature").getObjectByName("RootNode").getObjectByName("Hips")
        }
        this.animationMixer = new THREE.AnimationMixer(modelScene); //动作混合器
        // this.animationMixer.timeScale = 1.5;
        this.animationMixer.addEventListener('finished', this.actionFinished.bind(this));
        this.animationMixer.addEventListener('loop', this.onAnimationLoop.bind(this));

       

    }
    updateMixerDelate(deltaTime) {
        if (this.animationMixer) {
            this.animationMixer.update(deltaTime)

        }
    }
    //加载动作文件
    loadAction(actionFile,processCall) {
        return new Promise((resolve, reject) => {
            if (actionFile) {
                var fbxloader = new FBXLoader();
                fbxloader.load(actionFile, function (animation) {
                    // console.log('加载动作', animation)
                    if (animation.animations.length) {
                        animation = animation.animations[0]
                        console.log('动作时长度', animation.duration)
                        // 剪辑动画
                        const frameRate = animation.tracks[0].times.length / animation.duration; // 获取帧速率
                        const subclipAnimation = THREE.AnimationUtils.subclip(animation, 'subclip', START_FRAME,animation.duration*frameRate,frameRate);
                        subclipAnimation.resetDuration(animation.duration)
                        // console.log('动作subclip', subclipAnimation)
                        return resolve(subclipAnimation)
                    }
                    else {
                        return reject('未找到动作信息')
                    }

                },(process) => {
                   processCall && processCall(process)
                })
            }
            else {
                reject('没有找到动作，不绑定动作')
            }
        })
    }

    /**
     * 直接播放动作
     * @param {*} actionFile 
     * @returns 
     */
    playAction(actionFile) {
        this.loadAction(actionFile).then(animation => {
          
            var action = this.animationMixer.clipAction(animation,this.rootBone);
            this.setAction(actionFile, action)
            //从第一帧开始播放，播放一次
            action.setLoop(THREE.LoopOnce, START_FRAME)
            //播放结束后停在最后一帧
            action.clampWhenFinished = true;
            action.play()
            console.log('播放动作', actionFile)
        }, err => {
            console.log('加载动作文件失败', err)
        });
    }
    async loadFileToAction(actionFiles, idleActionFile,processCall) {

        let actionCount = actionFiles.length
        for (let i = 0; i < actionCount; ++i) {
            let actionFile = actionFiles[i]
            if (!this.getAction(actionFile)) {
                let animation = await this.loadAction(actionFile,(process)=>{
                    let percent
                    if (process.loaded >= process.total && i == actionCount - 1) {
                        percent = 100;
                    } else {
                        let itemProcess = process.loaded / process.total //将多个衣服的进度组成一个整体进度
                        let loadedProcess = ((1 / actionCount * itemProcess + (i / actionCount)) * 100).toFixed(2)
                        percent = loadedProcess;
                    }
                    if (processCall) {
                        processCall({
                            finished: percent == '100' ? true : false,
                            percent: percent
                        })
                    }
                })

                var action = this.animationMixer.clipAction(animation,this.rootBone);
                this.setAction(actionFile, action, actionFile == idleActionFile)
                console.log('load acion success', actionFile)
            }
        }
        this.activateIdelActions()
        return [null]
    }
    setIdleActionKey(actionKey) {
        this.idleActionKey = actionKey
    }
    getActionItem(actionKey) {
        if (this.actionsMap.has(actionKey)) {
            return this.actionsMap.get(actionKey)
        }
        else {
            return null
        }
    }

    setAction(actionKey, action, isIdleAction) {
        console.log('set action', actionKey)

        action.clampWhenFinished = true
        if (isIdleAction) {
            action.setLoop(THREE.LoopRepeat)
        }
        else action.setLoop(THREE.LoopOnce)

        this.actionsMap.set(actionKey, new ActionItem(action, actionKey, isIdleAction))
        if (isIdleAction) {
            this.idleActionKey = actionKey
        }
    }
    pauseAllActions() {
        this.actionsMap.forEach((action, key) => {
            action.pauseAction()
        })
    }
    unPauseAllActions() {
        this.actionsMap.forEach((action, key) => {
            action.unPauseAction()
        })
    }
    activateIdelActions() {
        this.idleActionKey && this.idleActionKey.length>0 && this.fadeToAction(this.idleActionKey, 1)
    }

    getAction(actionKey) {
        return this.actionsMap.get(actionKey)
    }
    actionFinished() {
        console.log('动作结束',this.currentActionKey)
        //恢复默认动作 
        if (this.currentActionKey != this.idleActionKey)
        {
            if(Date.now() - this.getAction(this.currentActionKey).playTime<2000){ //动作播放小于3秒中，需要等待3秒再结束
                setTimeout(()=>{
                    this.fadeToAction(this.idleActionKey, 0.5)
                },2000)
                
            }
            else{
                this.fadeToAction(this.idleActionKey, 0.5)
            }
            
        }
            
    }
    onAnimationLoop(event) {

    }

    fadeToAction(actionKey, duration, ignoreListener) {
        console.log('渐进动作',actionKey,duration)
        if (!this.getAction(actionKey)) {
            console.error('动作不存在', actionKey)
            return
        }

        let preActionKey = this.currentActionKey
   
        if (preActionKey ) {
     
            if(preActionKey != actionKey)//上一个动作淡出
                this.getAction(preActionKey) && this.getAction(preActionKey).action.fadeOut(duration || defaultCrossDuration)
            else //动作没有变化
            {
                console.log('新动作与旧动作相同')
                return 
            }
            
        }
        this.getAction(actionKey).action.clampWhenFinished = true
        this.getAction(actionKey).action.reset()
            .setEffectiveTimeScale(1)
            .setEffectiveWeight(1)
            .fadeIn(duration || defaultCrossDuration)
            .play();
        this.getAction(actionKey).updatePlayTime()
        this.currentActionKey = actionKey
    }
    /**
     * 释放所有动作文件
     */
    release(){
        this.actionsMap.forEach((action,key)=>{
            action.release()
        })
        this.actionsMap.clear()
    }
}


// WEBPACK FOOTER //
// ./src/S51WebGLSDK/action/actionMgr.js